import { render, staticRenderFns } from "./riskQuesDc.vue?vue&type=template&id=4b3ead81"
import script from "./riskQuesDc.vue?vue&type=script&lang=js"
export * from "./riskQuesDc.vue?vue&type=script&lang=js"
import style0 from "./riskQuesDc.vue?vue&type=style&index=0&id=4b3ead81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports